import React from 'react';
import Snackbar from '../Snackbar/Snackbar';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import { useIntl } from 'react-intl';

export default function ReconnectingNotification() {
  const { formatMessage } = useIntl();
  const roomState = useRoomState();

  return (
    <Snackbar
      variant="error"
      headline={formatMessage({ id: 'error.connection.headline' })}
      message={formatMessage({ id: 'error.connection.message' })}
      open={roomState === 'reconnecting'}
    />
  );
}
